import { __exports as r } from "../../../../_virtual/algorithms.js";
Object.defineProperty(r, "__esModule", {
  value: !0
}), r.iso7064Check = function (r) {
  for (var e = 10, t = 0; t < r.length - 1; t++) e = (parseInt(r[t], 10) + e) % 10 == 0 ? 9 : (parseInt(r[t], 10) + e) % 10 * 2 % 11;
  return (e = 1 === e ? 0 : 11 - e) === parseInt(r[10], 10);
}, r.luhnCheck = function (r) {
  for (var e = 0, t = !1, n = r.length - 1; n >= 0; n--) {
    if (t) {
      var o = 2 * parseInt(r[n], 10);
      o > 9 ? e += o.toString().split("").map(function (r) {
        return parseInt(r, 10);
      }).reduce(function (r, e) {
        return r + e;
      }, 0) : e += o;
    } else e += parseInt(r[n], 10);
    t = !t;
  }
  return e % 10 == 0;
}, r.reverseMultiplyAndSum = function (r, e) {
  for (var t = 0, n = 0; n < r.length; n++) t += r[n] * (e - n);
  return t;
}, r.verhoeffCheck = function (r) {
  for (var e = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], t = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], n = r.split("").reverse().join(""), o = 0, a = 0; a < n.length; a++) o = e[o][t[a % 8][parseInt(n[a], 10)]];
  return 0 === o;
};
export { r as default };